import {type ReactNode} from 'react'
import {useTranslation} from 'react-i18next'
import type {PatientReportSlotResponse} from '@common/models'
import {useEnumTranslations} from '@common/utils/translations'
import {EnumType} from '@common/utils/types'

import {Tooltip} from '~/components/general/tooltip/Tooltip'
import {Typography} from '~/components/general/typography/Typography'

type SlotItemTooltipProps = {
  slot: PatientReportSlotResponse
  children: ReactNode
}

export const SlotItemTooltip = ({slot, children}: SlotItemTooltipProps) => {
  const {t} = useTranslation()
  const {translateEnumValue} = useEnumTranslations()
  const translatedStatus = translateEnumValue(
    EnumType.SlotStatusType,
    slot.status,
  )

  return (
    <Tooltip
      content={
        <>
          <Typography size="sm" color="#fff" weight="medium">
            {t('Time')}: {slot.time}
          </Typography>
          {!!slot.patient && (
            <Typography size="sm" color="#fff">
              {t('Patient')}: {slot.patient}
            </Typography>
          )}
          <Typography size="sm" color="#fff" weight="medium">
            {t('Status')}: {translatedStatus}
          </Typography>
          {!!slot.staff && (
            <Typography size="sm" color="#fff">
              {t('Staff')}: {slot.staff}
            </Typography>
          )}
        </>
      }
      placement="top"
      align="start"
      inline={false}
      nowrap>
      {children}
    </Tooltip>
  )
}
